<mat-sidenav-container (backdropClick)="close()" class="sidenav-support" id="sidenav-support">
  <mat-sidenav-content class="side-nav-content">
    <ng-content></ng-content>
  </mat-sidenav-content>
  <mat-sidenav #sidenav (keydown.escape)="close()" [disableClose]="true" [fixedBottomGap]="10" [fixedInViewport]="true"
               [fixedTopGap]="10" class="side-nav side-nav-{{size}}">
    <ng-container *ngTemplateOutlet="sideNavTemplateRef"></ng-container>
  </mat-sidenav>
</mat-sidenav-container>
